import { render } from "./RewardsPage.vue?vue&type=template&id=d3a1bb20&scoped=true"
import script from "./RewardsPage.vue?vue&type=script&lang=js"
export * from "./RewardsPage.vue?vue&type=script&lang=js"

import "./RewardsPage.vue?vue&type=style&index=0&id=d3a1bb20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a1bb20"]])

export default __exports__